import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DateTime } from '@mode-switch/express';
import { ButtonComponent, IconComponent } from '@mode/capra';
import { MetaTags, MetaTagsService, LocalStorageService, getAppName } from '@mode/shared/util-js';
import { AnalyticsEvent, AnalyticsService } from '@mode/shared/util-segment';

@Component({
  standalone: true,
  selector: 'mode-account-connection-cta',
  imports: [ButtonComponent, CommonModule, IconComponent],
  templateUrl: './account-connection-cta.component.html',
  styleUrls: ['./account-connection-cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountConnectionCtaComponent {
  @Input({ required: true }) link = '';
  readonly appName = getAppName();
  readonly isAnalystStudio = this.thoughtspotIntegrationService.currOrgIntegrated();

  constructor(
    private analyticsService: AnalyticsService,
    private meta: MetaTagsService,
    private localStorageService: LocalStorageService,
    private thoughtspotIntegrationService: ThoughtspotIntegrationService
  ) {}

  redirect() {
    this.sendgSheetAnalyticsEvent();
    window.location.href = this.link;
  }
  sendgSheetAnalyticsEvent() {
    const eventData = {
      location: AnalyticsEvent.SubContext.GoogleSheetSetup,
      action: 'setup-started',
      session_ID: this.localStorageService.getItem('LAST_ACTIVE_TAB_ID'),
      user_ID: this.meta.getTag(MetaTags.CurrentUsername),
      timestamp: DateTime,
      capture_URL: this.link,
    };
    this.analyticsService.track(AnalyticsEvent.Name.GoogleSheetSetup, eventData);
  }
}
